import request from '@/api/request.js';

// 招生话术列表
export const getCmsSpeechcraftListPage = (data) => {
    return request({
        url: '/cms/adm/cmsSpeechcraft/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 添加招生话术
export const addCmsSpeechcraft = (data) => {
    return request({
        url: '/cms/adm/cmsSpeechcraft/addCmsSpeechcraft',
        method: 'post',
        type: 'json',
        data
    })
}

// 编辑招生话术
export const updateCmsSpeechcraft = (data) => {
    return request({
        url: '/cms/adm/cmsSpeechcraft/updateCmsSpeechcraft',
        method: 'post',
        type: 'json',
        data
    })
}

// 删除话术分类
export const delCmsSpeechcraft = (data) => {
    return request({
        url: '/cms/adm/cmsSpeechcraft/delCmsSpeechcraft',
        method: 'post',
        data
    })
}

// 话术分类列表
export const getSpeechcraftClassifyListPage = (data) => {
    return request({
        url: '/cms/adm/speechcraftClassify/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 添加话术分类
export const addSpeechcraftClassify = (data) => {
    return request({
        url: '/cms/adm/speechcraftClassify/addSpeechcraftClassify',
        method: 'post',
        type: 'json',
        data
    })
}

// 编辑话术分类
export const updateSpeechcraftClassify = (data) => {
    return request({
        url: '/cms/adm/speechcraftClassify/updateSpeechcraftClassify',
        method: 'post',
        type: 'json',
        data
    })
}

// 删除话术分类
export const delSpeechcraftClassify = (data) => {
    return request({
        url: '/cms/adm/speechcraftClassify/delSpeechcraftClassify',
        method: 'post',
        data
    })
}